// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.base-image {
  position: relative;
}
.base-image img {
  width: 100%;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/pages/marketing/components/base-image/index.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AAFA;EAII,WAAA;EACA,cAAA;AACJ","sourcesContent":[".base-image {\n  position: relative;\n\n  img {\n    width: 100%;\n    display: block;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
